import { SelectOption } from '@/src/components/atom/Select';
import {
  ArrayFilters,
  DefaultFilters,
  ListFilterTypeObject,
  WithOptionsFilterFilters,
} from '@/src/components/organism/Filter/types';

export const bannerFilters: (
  bannerContentCategoryOptions: SelectOption[],
) => (
  | DefaultFilters
  | WithOptionsFilterFilters
  | ArrayFilters
)[] = bannerContentCategoryOptions => [
  {
    key: 'id',
    label: 'ID',
    placeholder: 'ID를 입력해주세요',
    type: 'TEXT',
  },
  {
    key: 'postedAt',
    label: '게시 시작 일자',
    type: 'DATE_RANGE',
    rangeKeys: ['bannerPostBeginStartedAt', 'bannerPostBeginEndedAt'],
  },
  {
    key: 'bannerMarketingYn',
    label: '광고 여부',
    placeholder: '전체',
    options: [
      { label: '전체', value: '' },
      { label: '광고', value: 'true' },
      { label: '일반', value: 'false' },
    ],
    type: ListFilterTypeObject.SELECT,
  },
  {
    key: 'createdAt',
    label: '등록 일자',
    type: 'DATE_RANGE',
    rangeKeys: ['createdAtFrom', 'createdAtTo'],
  },
  {
    key: 'bannerShowedYn',
    label: '노출 여부',
    placeholder: '전체',
    options: [
      { label: '전체', value: '' },
      { label: '노출', value: 'true' },
      { label: '미노출', value: 'false' },
    ],
    type: ListFilterTypeObject.SELECT,
  },
  {
    key: 'adminName',
    label: '등록 관리자',
    placeholder: '관리자명을 입력해주세요',
  },
  {
    key: 'bannerTitle',
    label: '제목',
    placeholder: '배너 제목을 입력해주세요',
  },
  {
    key: 'bannerConnectedType',
    label: '연결 컨텐츠',
    placeholder: '전체',
    options: bannerContentCategoryOptions,
    type: ListFilterTypeObject.SELECT,
  },
];
